import React from 'react'

const EditIcon = () => {
  return (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="34" height="34" rx="17" fill="white"/>
<rect x="0.5" y="0.5" width="34" height="34" rx="17" stroke="#3249D7"/>
<path fillRule="evenodd" clipRule="evenodd" d="M22.7169 12.9077C22.9505 12.6827 22.9505 12.3193 22.7169 12.0943L21.3154 10.7443C21.0818 10.5193 20.7044 10.5193 20.4708 10.7443L19.2969 11.875L21.543 14.0385L22.7169 12.9077ZM20.944 14.6154L18.6979 12.4519L12.7083 18.2212V20.3846H14.9544L20.944 14.6154ZM24.6875 22.1154H10.3125V24.4231H24.6875V22.1154Z" fill="#3249D7"/>
</svg>
  )
}

export default EditIcon
